var map = {
	"./Sicredi-Joao.webm": 9724,
	"./Sicredi-Marta.webm": 6243,
	"./Sicredi-Pedro.webm": 7032,
	"./Sicredi_PI_sequence_transparent_intro.webm": 9405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6506;